import type { ReactElement, SVGProps } from 'react'
import { Icon } from './Icon'

export function Cog(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <Icon {...props}>
      <path
        fill="#444"
        d="M29.181 19.07c-1.679-2.908-.669-6.634 2.255-8.328l-3.145-5.447a6.022 6.022 0 01-3.058.829c-3.361 0-6.085-2.742-6.085-6.125h-6.289a6.023 6.023 0 01-.811 3.07C10.369 5.977 6.637 6.966 3.709 5.28L.565 10.727a6.023 6.023 0 012.246 2.234c1.676 2.903.672 6.623-2.241 8.319l3.145 5.447a6.022 6.022 0 013.044-.82c3.35 0 6.067 2.725 6.084 6.092h6.289a6.032 6.032 0 01.811-3.038c1.676-2.903 5.399-3.894 8.325-2.219l3.145-5.447a6.032 6.032 0 01-2.232-2.226zM16 22.479A6.48 6.48 0 1116 9.52a6.48 6.48 0 010 12.959z"
      />
    </Icon>
  )
}
